import {createReducer, on} from "@ngrx/store";
import * as HangarActions from './hangar-queue.actions';
import {HangarQueue} from "../../models/HangarQueue";
export const HangarQueueFeatureKey = 'hangarQueue';
export const HangarQueueInitialState: HangarQueue[] = null;
export const HangarQueueReducer = createReducer<HangarQueue[] | null>(
  HangarQueueInitialState,
  on(HangarActions.update, (_state, { hangarQueue }) => hangarQueue),
);
